export interface ConnectivityEventTarget {
  addEventListener(type: 'online' | 'offline', listener: () => void): void;
  removeEventListener(type: 'online' | 'offline', listener: () => void): void;
}

export interface ConnectivityRuntime {
  getOnline(): boolean;
  events: ConnectivityEventTarget;
}

export interface ConnectivityStore {
  getSnapshot(): boolean;
  getServerSnapshot(): boolean;
  subscribe(listener: () => void): () => void;
}

export function createConnectivityStore(
  runtime: ConnectivityRuntime,
): ConnectivityStore {
  return {
    getSnapshot: () => runtime.getOnline(),
    getServerSnapshot: () => runtime.getOnline(),
    subscribe(listener) {
      const notify = (): void => listener();
      runtime.events.addEventListener('online', notify);
      runtime.events.addEventListener('offline', notify);
      return () => {
        runtime.events.removeEventListener('online', notify);
        runtime.events.removeEventListener('offline', notify);
      };
    },
  };
}

const fallbackEvents: ConnectivityEventTarget = {
  addEventListener: () => undefined,
  removeEventListener: () => undefined,
};

export const browserConnectivityStore = createConnectivityStore({
  getOnline: () =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  events: typeof window === 'undefined' ? fallbackEvents : window,
});
